import React from "react";
import { useTranslation } from "react-i18next";
// misc.
import { staticLinks } from "@config/staticLinks";
// mantine
import { Text, Title, Anchor, Box } from "@mantine/core";
// misc ui coponents
import { PasswordResetCard } from "@components/password-reset-card/password-reset-card";

export const PasswordResetDone = React.memo<{ isFlowComplete?: boolean }>(
  function PasswordResetDone(props) {
    const { isFlowComplete = false } = props;

    const { t } = useTranslation();
    return (
      <PasswordResetCard>
        <Title order={2} data-testid="pw-reset-done-title">
          {t(
            `passwordReset.done.${isFlowComplete ? "lastStepTitle" : "title"}`,
          )}
        </Title>

        {!isFlowComplete && (
          <Text data-testid="pw-reset-done-text" mt="lg">
            {t("passwordReset.done.instructions")}
          </Text>
        )}

        <Box mt="lg">
          <Anchor
            href={staticLinks.loginToHub}
            fw="bold"
            data-testid="pw-reset-login-link"
          >
            {t("passwordReset.done.logIn")}
          </Anchor>
        </Box>
      </PasswordResetCard>
    );
  },
);

export const PasswordResetFinalStep = React.memo(() => (
  <PasswordResetDone isFlowComplete />
));
PasswordResetFinalStep.displayName = "PasswordResetFinalStep";
